/* global jQuery COMPONENTS google propertyLocations locationProperty googleMapsStyler */

COMPONENTS.ComponentNeighborhoods = (function ($) {
  function ComponentNeighborhoods () {
    // Component-global variable declarations
    this.$component = $('[data-ecs-component="component-neighborhoods"]')
  }

  ComponentNeighborhoods.prototype.init = function () {
    const component = this
    const $neighborhoodSelector = $('#neighborhood-select');

    if ($neighborhoodSelector) {
      $neighborhoodSelector.on('change', function() {
        const url = $(this).val();
        console.log('openLink is running with:', $(this))

        if (url) {
          window.location.href = url;
        }
      });
    }
  }

  return ComponentNeighborhoods
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init

  if (pageComponentsList.includes('component-neighborhoods')) {
    COMPONENTS.ComponentNeighborhoods = new COMPONENTS.ComponentNeighborhoods()
    COMPONENTS.ComponentNeighborhoods.init()
  }
})
